<template>
  <div>
    <div v-if="saved">
      <p style="text-align: center">
        You have successfully changed your preferences. Back to Wallet.
      </p>
      <div @click="back" style="text-align: center">
        <IOSWalletButton v-if="isIOS" />
        <AndroidWalletOpenButton v-if="isAndroid" />
      </div>
    </div>
    <p>Change preferences</p>
    <CategoryCheckboxList
      v-if="initialized"
      v-on:change="handleChecboxChange"
      :categoryIds="categories"
    />
    <Button label="Save" v-on:click="handleSubmit" />
  </div>
</template>

<script>
import CategoryCheckboxList from "@/components/CategoryCheckboxList.vue";
import Button from "@/components/Button.vue";
import { isIOS, isAndroid } from "mobile-device-detect";
import allCategories from "../constants/categories";
import Axios from "axios";
import AndroidWalletOpenButton from "@/components/AndroidWalletOpenButton.vue";
import IOSWalletButton from "@/components/IOSWalletButton.vue";

export default {
  //layout: (ctx) => (ctx.isMobile ? 'mobile' : 'default')

  components: {
    CategoryCheckboxList,
    Button,
    AndroidWalletOpenButton,
    IOSWalletButton
  },

  props: {
    passId: String
  },

  async mounted() {
    this.$store.commit("loading", true);
    const response = await Axios.get(
      `${process.env.VUE_APP_API_URLBASE}/pass/${this.passId}`
    );
    const items = [];
    if (response.data.dynamicData) {
      Object.keys(response.data.dynamicData).forEach((key, index) => {
        if (response.data.dynamicData[key] !== "disabled") {
          items.push(key);
        }
      });
    }
    this.categories = items;
    this.initialized = true;
    this.$store.commit("loading", false);
  },

  data: () => {
    return {
      categories: [],
      initialized: false,
      saved: false,
      isIOS,
      isAndroid
    };
  },

  methods: {
    handleChecboxChange(data) {
      this.categories = data;
    },
    async handleSubmit() {
      this.$store.commit("loading", true);
      const dynamicData = {};
      try {
        allCategories.forEach(cat => {
          dynamicData[cat.id] = this.categories.includes(cat.id)
            ? ""
            : "disabled";
        });
        const body = {
          dynamicData: dynamicData
        };
        const response = await Axios.put(
          `${process.env.VUE_APP_API_URLBASE}/pass/${this.passId}`,
          body
        );
        this.saved = true;
      } catch (e) {
        // TODO - handle
      }
      this.$store.commit("loading", false);
    },
    back() {
      if (isIOS) {
        window.open("shoebox://");
      }
      if (isAndroid) {
        window.open(
          "intent:#Intent;scheme=yourwallet;package=eu.yourpass.wallet;end"
        );
      }
    }
  }
};
</script>
